import { render, staticRenderFns } from "./DeleteOrCloneRenderer.vue?vue&type=template&id=086aa312"
import script from "./DeleteOrCloneRenderer.vue?vue&type=script&lang=js"
export * from "./DeleteOrCloneRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports